// extracted by mini-css-extract-plugin
module.exports = {"container":"_2gGWBeLWLA3AjF4hwd0aaK","imgPlaceholder":"_20oWq4heBctmfcLN6PMCR9","text":"_1mUWvlLawb-jk1c0sHllyO"};